export default {
  JSON: "json",
  TEXT: "text",
};
